import React from 'react'
import axios from 'axios'

export default class StaticPage extends React.Component {
    constructor() {
        super()
        this.state = {}
    }
    componentWillMount() {
        this.loadContent(this.props.route.path)
    }
    componentWillReceiveProps({ route }) {
        if (route.path !== this.props.route.path) {
            this.loadContent(route.path)
        }
    }
    loadContent(path) {
        this.setState({
            content: null,
            error: null
        })
        axios.request(`${path}.html`)
            .then(response => this.setState({ content: response.data }))
            .catch(error => this.setState({ error }))
    }
    render() {
        const { content, error } = this.state
        if (content) {
            return <div dangerouslySetInnerHTML={{ __html: content }} />
        } else if (error) {
            return <div>Page could not be found</div>
        } else {
            return <div>Loading...</div>
        }
    }
}


// WEBPACK FOOTER //
// ./components/StaticPage.jsx